import styles from 'theme/features/dashboard/export/export-actions.module.scss';

const ExportActions = ({ children }) => <div className={styles.actions}>{children}</div>;

export default ExportActions;
